module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part01"
    }
  }, [_c('div', {
    staticClass: "partHead",
    attrs: {
      "id": "ph01"
    }
  }, [_c('h2', {
    staticClass: "partNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062016706_Contents#part_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("[ PART ONE ]")])])])]), _vm._v(" "), _c('div', {
    staticClass: "partEpigraph",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('p', {
    staticClass: "partEpigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nothing that is worth doing can be achieved in our lifetime; therefore we must be saved by hope. Nothing which is true or beautiful or good makes complete sense in any immediate context of history; therefore we must be saved by faith. Nothing we do, however virtuous, can be accomplished alone; therefore we must be saved by love.")])]), _vm._v(" "), _c('p', {
    staticClass: "partEpigraphSource",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EINHOLD")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IEBUHR")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b06c134","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062016706_Part_1.vue
// module id = 72
// module chunks = 0